import isPublicView from "app/utils/publicViewUtils";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PublicLoginRegister from "./components/PublicLoginRegister";

const LoginContact = (props: { setRegistrationModalOpen: () => void }) => {
  // no idea why props.props is getting returned
  if (isPublicView()) {
    return <PublicLoginRegister />;
  }

  return (
    <React.Fragment>
      <Link to="/login" className="nav-bar__nav-item--login">
        <span className="nav-bar__nav-item--login-text">
          <FormattedMessage tagName="span" id="login-login" />
        </span>
      </Link>
      <button
        className="nav-bar__nav-item--contact nav-bar__nav-item--contact--button"
        onClick={() => {
          props.setRegistrationModalOpen();
        }}
      >
        <FormattedMessage tagName="span" id="home-cta-register" />
      </button>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  isRegistrationModalOpen: state.registrationFormModel.isRegistrationModalOpen,
});

function mapDispatchToProps(dispatch) {
  return {
    setRegistrationModalOpen: () => {
      dispatch.registrationFormModel.setRegistrationModalOpen();
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginContact) as any;
